import {BaseMapData} from './BaseMapData.ts'
import {StoreExpansionType, LobbyImage, ModeSettingEnum, ScenarioSettingEnum, MapSettingEnum} from '@colonist/types'
import {type TranslationObject} from '@colonist/i18n'

export class MapDataSS1HeadingForNewShores3P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers4P, StoreExpansionType.CitiesAndKnightsSeafarers4P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.SS1HeadingForNewShores3P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.headingForNewShores', options: {count: 3}}
    image = LobbyImage.MapSS1HeadingForNewShores3PPreview
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers4P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 22

    scenario = ScenarioSettingEnum.SS1HeadingForNewShores
}

export class MapDataSS2FourIslands3P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers4P, StoreExpansionType.CitiesAndKnightsSeafarers4P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.SS2FourIslands3P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.fourIslands', options: {count: 3}}
    image = LobbyImage.MapSS2FourIslands3PPreview
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers4P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 20

    scenario = ScenarioSettingEnum.SS2TheFourIslands
}

export class MapDataSS3FogIslands3P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers4P, StoreExpansionType.CitiesAndKnightsSeafarers4P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.SS3FogIslands3P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.fogIslands', options: {count: 3}}
    image = LobbyImage.MapSS3FogIslands3PPreview
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers4P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 24

    scenario = ScenarioSettingEnum.SS3TheFogIslands
}

export class MapDataSS4ThroughTheDesert3P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers4P, StoreExpansionType.CitiesAndKnightsSeafarers4P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.SS4ThroughTheDesert3P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.throughTheDesert', options: {count: 3}}
    image = LobbyImage.MapSS4ThroughTheDesert3PPreview
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers4P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 25

    scenario = ScenarioSettingEnum.SS4ThroughTheDesert
}

export class MapDataSS1HeadingForNewShores4P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers4P, StoreExpansionType.CitiesAndKnightsSeafarers4P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.SS1HeadingForNewShores4P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.headingForNewShores', options: {count: 4}}
    image = LobbyImage.MapSS1HeadingForNewShores4PPreview
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P, ModeSettingEnum.CitiesAndKnightsSeafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers56P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 28

    scenario = ScenarioSettingEnum.SS1HeadingForNewShores
}

export class MapDataSS2FourIslands4P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers4P, StoreExpansionType.CitiesAndKnightsSeafarers4P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.SS2FourIslands4P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.fourIslands', options: {count: 4}}
    image = LobbyImage.MapSS2FourIslands4PPreview
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P, ModeSettingEnum.CitiesAndKnightsSeafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers56P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 23

    scenario = ScenarioSettingEnum.SS2TheFourIslands
}

export class MapDataSS3FogIslands4P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers4P, StoreExpansionType.CitiesAndKnightsSeafarers4P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.SS3FogIslands4P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.fogIslands', options: {count: 4}}
    image = LobbyImage.MapSS3FogIslands4PPreview
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P, ModeSettingEnum.CitiesAndKnightsSeafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers56P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 27

    scenario = ScenarioSettingEnum.SS3TheFogIslands
}

export class MapDataSS4ThroughTheDesert4P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers4P, StoreExpansionType.CitiesAndKnightsSeafarers4P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.SS4ThroughTheDesert4P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.throughTheDesert', options: {count: 4}}
    image = LobbyImage.MapSS4ThroughTheDesert4PPreview
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P, ModeSettingEnum.CitiesAndKnightsSeafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers56P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 30

    scenario = ScenarioSettingEnum.SS4ThroughTheDesert
}

// Dec 8, 2020. Jeff this is only included to define settings for Seafarers test files.
// This can be cleaned up if an actual tutorial is made
export class MapDataTutorialSS1HeadingForNewShores4P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers4P, StoreExpansionType.CitiesAndKnightsSeafarers4P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.TutorialSS1HeadingForNewShores4P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.tutorialHeadingForNewShores4P'}
    image = LobbyImage.MapSS1HeadingForNewShores4PPreview
    compatibleGameModes = []
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 28

    scenario = ScenarioSettingEnum.SS1HeadingForNewShores
}

export class MapDataTutorialSS2FourIslands4P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers4P, StoreExpansionType.CitiesAndKnightsSeafarers4P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.TutorialSS2FourIslands4P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.tutorialFourIslands4P'}
    image = LobbyImage.MapSS2FourIslands4PPreview
    compatibleGameModes = []
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 23

    scenario = ScenarioSettingEnum.SS2TheFourIslands
}

export class MapDataTutorialSS3FogIslands4P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers4P, StoreExpansionType.CitiesAndKnightsSeafarers4P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.TutorialSS3FogIsland4P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.tutorialFogIslands4P'}
    image = LobbyImage.MapSS3FogIslands4PPreview
    compatibleGameModes = []
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 27

    scenario = ScenarioSettingEnum.SS3TheFogIslands
}

export class MapDataTutorialSS4ThroughTheDesert4P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers4P, StoreExpansionType.CitiesAndKnightsSeafarers4P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.TutorialSS4ThroughTheDesert4P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.tutorialThroughTheDesert4P'}
    image = LobbyImage.MapSS4ThroughTheDesert4PPreview
    compatibleGameModes = []
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 30

    scenario = ScenarioSettingEnum.SS4ThroughTheDesert
}
